import { render, staticRenderFns } from "./explore_telescope.vue?vue&type=template&id=48a72ac7&scoped=true&"
import script from "./explore_telescope.vue?vue&type=script&lang=js&"
export * from "./explore_telescope.vue?vue&type=script&lang=js&"
import style0 from "./explore_telescope.vue?vue&type=style&index=0&id=48a72ac7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a72ac7",
  null
  
)

export default component.exports